var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-card"},[_c('b-card',{attrs:{"title":_vm.title}},[_c('span',{class:_vm.getClass(_vm.icon)}),_c('b-card-text',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }